// reducer.js
import {
  GET_FEEDBACK_REQUEST,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: [],
};

const getFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FEEDBACK_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_FEEDBACK_SUCCESS:
      console.log("response444",action.payload.data);
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    case GET_FEEDBACK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default getFeedbackReducer;
